/**
 * Глубокое копирование обьекта избавление от реактивности 
 * @param val
 */
export default (val)=>{
  return JSON.parse(JSON.stringify(val))
}
